import React, { useState } from "react"
import styled from "styled-components"
import { useQuery } from "@apollo/client"
import { showEditSidebar } from "lib/store/services/editSidebar/slice"
import { useDispatch } from "react-redux"

import ALL_GIFT_CARD_PROVIDERS from "graphql/queries/config/AllGiftCardProviders"

import PageHeader from "components/Ui/Page/PageHeader"
import PrimaryButton from "components/Ui/Buttons/PrimaryButton"
import { CustomGiftCardConfigTable } from "components/Config/CustomGiftCard/CustomGiftCardConfigTable"
import { EditCustomGiftCardConfig } from "./EditCustomGiftCardConfig"
import { CreateCustomGiftCardConfig } from "./CreateCustomGiftCardConfig"

import { ReactComponent as PlusIcon } from "images/icons/plus.svg"
import { ReactComponent as CardIcon } from "images/icons/credit-card.svg"
import { WithAuth } from "../../../../components/Auth"
import { PermissionGroups } from "../../../../routes/constants"

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`

const StyledCardIcon = styled(CardIcon)`
  height: 3.5rem;
  margin-right: 1.5rem;
`

export const CustomGiftCardConfiguration = () => {
  const [editId, setEditId] = useState<string>("")
  const { loading, data, refetch, error } = useQuery(ALL_GIFT_CARD_PROVIDERS)
  const dispatch = useDispatch()
  const giftCardProviders = data?.getGiftCardProviders

  return (
    <Container>
      <PageHeader
        title={
          <>
            <StyledCardIcon /> Brink Custom Gift Card
          </>
        }
        description={<>Handle your Brink Custom Gift Card configuration</>}
        goBackLinkText="Back to providers"
        goBackLinkUrl={"/settings/providers"}
      >
        <WithAuth requiredGroups={PermissionGroups.providers.write}>
          <PrimaryButton type="button" handleClick={() => dispatch(showEditSidebar())}>
            <PlusIcon /> Add new configuration
          </PrimaryButton>
        </WithAuth>
      </PageHeader>
      {!editId && <CreateCustomGiftCardConfig refetch={refetch} />}
      {editId && (
        <EditCustomGiftCardConfig refetch={refetch} editId={editId} setEditId={setEditId} />
      )}
      <CustomGiftCardConfigTable
        providers={giftCardProviders}
        loading={loading}
        error={error}
        setEditId={setEditId}
      />
    </Container>
  )
}
